import React from 'react';
import { message } from 'antd';
import { isEmpty } from 'lodash';
import { inject, observer } from 'mobx-react';
import { LoadingSpinner2 } from '@gtintel/platform-atoms';
import { COOKIE_NAMES } from '@gtintel/platform-constants';
import { BatchType } from '@gtintel/platform-types';
import { getSessionStorageItem } from '@gtintel/platform-utils';
import AssignmentButton from './AssignmentButton';
import { displayChatPopup } from './displayChatPopup';

// Copied from: apps/platform-admin/src/components/Pages/Admin/Project/Detail/utils'
function scrollHorizontal(loca) {
  if (loca !== 0) {
    this.scrollToChat.scrollTo(Number(loca) - 15, 0);
  } else {
    this.scrollToRight();
  }
}
function scrollToRight() {
  this.listpopupchat?.scrollIntoView({
    inline: 'center',
    block: 'end'
  });
}

/// apps/platform-admin/src/components/Pages/Admin/Project/Detail/utils'

class AssignmentButtonStateContainer extends React.Component {
  constructor(props) {
    super(props);
    this.displayChatPopup = void 0;
    this.scrollHorizontal = void 0;
    this.scrollToRight = void 0;
    this.openChats = channelInfo => {
      if (!this[`child${channelInfo.channelSid}`]) {
        this.displayChatPopup({
          identity: channelInfo.identity,
          channel_sid: channelInfo.channelSid,
          popupName: channelInfo.popupName,
          groupMembers: channelInfo.groupMembers,
          typeChat: 'project',
          hideHeader: false,
          isAssignmentPartnerChat: true
        });
        setTimeout(() => {
          if (this[`child${channelInfo.channelSid}`].openChat) {
            this[`child${channelInfo.channelSid}`].openChat(channelInfo.channelSid);
          }
        }, 100);
      } else {
        if (this[`child${channelInfo.channelSid}`].closeChat) {
          this[`child${channelInfo.channelSid}`].closeChat();
        }
      }
    };
    this.state = {
      chatPopup: null,
      listChatConnecting: [],
      loading: true,
      projects: null
    };

    //chat methods
    this.scrollHorizontal = scrollHorizontal.bind(this);
    this.scrollToRight = scrollToRight.bind(this);
    this.displayChatPopup = displayChatPopup.bind(this);
  }
  static async getInitialProps({
    projectId
  }) {
    return {
      projectId
    };
  }
  componentDidMount() {
    this.fetchProjectData();
  }
  componentDidUpdate(prevProps) {
    if (this.props.projectId !== prevProps.projectId) {
      this.setState({
        loading: true
      }, () => {
        this.fetchProjectData();
      });
    }
  }
  async fetchProjectData() {
    try {
      // Make sure we don't hide the loading spinner false until all these
      // calls are finished, or the UI looks janky
      await Promise.all([this.props.adminProjectDetailStore.fetchProjectDetail(Number(this.props.projectId)).then(() => {
        const {
          projectDetail
        } = this.props.adminProjectDetailStore;
        if (projectDetail) {
          this.props.adminProjectDetailStore.setBatchType(projectDetail.source || BatchType.STANDARD);
          const projects = {
            ...projectDetail,
            statusDetail: projectDetail.status,
            typeBatch: projectDetail.source
          };
          this.setState({
            projects
          });
        }
      }).catch(console.error)]);
    } catch {
      message.error('An unknown error occurred.');
    } finally {
      this.setState({
        loading: false
      });
    }
  }
  render() {
    const {
      projects,
      chatPopup
    } = this.state;
    const openChats = this.openChats;
    if (!projects) return null;

    // If you're not logged in then this component shouldn't be rendered in the
    // first place - but guard against it to prevent weird errors during logout.
    const user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);
    if (!user) return null;
    return <div>
        {this.state.loading || isEmpty(projects) ? <LoadingSpinner2 margin="150px" /> : <AssignmentButton onConnect={channel => openChats(channel)} project={projects} user={user} />}
        {chatPopup}
      </div>;
  }
}
export default inject('adminProjectDetailStore')(inject('partnerStore')(observer(AssignmentButtonStateContainer)));